module.exports = __webpack_public_path__ + "static/img/Jagga-Smith.71e059d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jagga-Smith.jpg
// module id = FpwZ
// module chunks = 0